import { ref, type Ref } from 'vue';
import { AxiosRequestController } from '@/modules/core/app/models/AxiosRequestController';

export const activeRequests: Ref<AxiosRequestController[]> = ref([]);
export const allowedRequestUrl: Ref<string | undefined> = ref(undefined);
